import { render, staticRenderFns } from "./PaginationIcon.vue?vue&type=template&id=3baa51cb&"
import script from "./PaginationIcon.vue?vue&type=script&lang=js&"
export * from "./PaginationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports